import { Theme } from "@mui/material/styles";

export const Variants = (theme: Theme) => {
    return {
      Primary: {
        border: "0.25rem solid",
        borderColor: theme.colors["neutral.950"],
      },

      Warning: {
        border: "0.25rem solid",
        borderColor: theme.colors["red.800"]
      },

      Secondary: {
        border: "0.25rem solid",
        borderColor: theme.colors["neutral.950"]
      },
  };
};

export const GradientStyles = (theme: Theme) => {
  return {
    gradient1: {
      backgroundImage: theme.utils.verticalLinearGradient("vertical", "darktolight"),
    },
    gradient2: {
      backgroundImage: theme.utils.verticalLinearGradient("vertical", "redtopink"),
    },
  };
};
